<template>
  <section>
    <v-flex xs12 md12 pt-2 pl-2 pr-2>
      <v-card v-if="!loading">
        <v-card-title primary-title class="headline primary">
          <v-layout row>
            <v-flex xs11 md11>
              <v-btn
                dark
                icon
                @click="$router.push('/settings/pricing/ride_types/')"
              >
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <span class="title font-weight-light white--text">
                Update Ride Type:
                <b>{{ rideType.name }}</b>
              </span>
            </v-flex>
            <v-flex xs1 md1 pb-1>
              <v-container pa-0 ma-0>
                <v-layout justify-center align-center>
                  <v-avatar :size="45">
                    <img :src="rideType.picture" />
                  </v-avatar>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text key="1">
          <RideTypeForm
            ref="rideTypeForm"
            :disabled="disabled"
            :rideType="rideType"
            :tariff="tariff"
            :errors="errors"
            @validityChange="updateFormValidity($event)"
            @imageInput="handleImageInput"
            @alternativeImageInput="handleAlternativeImageInput"
          />
          <v-layout align-center justify-left>
            <h4 class="grey--text text--darken-1">Current Modifiers -&nbsp;</h4>
            <h5 class="nobold grey--text text--darken-1">
              Drag and drop to re-order
            </h5>
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              class="text-none pa-1"
              text
              @click="addTariffModifier()"
              >Add Tariff Modifier</v-btn
            >
          </v-layout>
          <v-flex pt-2>
            <TariffModifierList
              :modifiers="tariff.modifiers"
              @edit="editTariffModifier($event)"
              @orderChange="changeModifierOrder($event)"
            />
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="text-none" @click="update"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
      <br>
      <v-card v-if="!loading">
        <v-card-title primary-title class="headline primary">
           <span class="title font-weight-light white--text">
            Luggage And Passenger Capacity
          </span>
          <v-spacer></v-spacer>
          <v-btn @click="showLuggageFormDialog = true">
            Add
          </v-btn>
        </v-card-title>
        <v-card-text key="1">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Num Seats
                </th>
                <th class="text-left">
                  Max Luggage
                </th>
                <th class="text-left">
                  Body Type
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="item in rideType.rideTypeCapacity"
                :key="item.id"
              >
                <td>{{ item.num_seats }}</td>
                <td>{{ item.max_luggage }}</td>
                <td>{{ item.body_type }}</td>
                <td>
                  <v-icon title="Delete record" @click="deleteRecord(item.id)">mdi-close</v-icon>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <RideTypeLuggagePassengerForm :ride-type-info="rideType" @saved="getRideTypeInfo" @closeDialog="showLuggageFormDialog = false" :dialog="showLuggageFormDialog"></RideTypeLuggagePassengerForm>
        </v-card-text>
      </v-card>
      <TariffModifierForm
        v-if="showModifierDialog"
        ref="tariffModifierForm"
        :show="showModifierDialog"
        :modifierData="tariffModifierData"
        :errors="errors.tariff ? errors.tariff.modifiers[modifierIndex] : {}"
        @cancel="cancelTariffModifier()"
        @save="saveTariffModifier($event)"
        @snackbar="showSnackbar($event.message, $event.colour)"
      />
      <v-snackbar
        v-model="snackbarShow"
        :color="snackbarColour"
        :timeout="4000"
        >{{ snackbarMessage }}</v-snackbar
      >
    </v-flex>
  </section>
</template>

<script>
import RideTypeForm from "@/components/settings/pricing/RideTypeForm.vue";
import TariffModifierForm from "@/components/settings/pricing/TariffModifierForm.vue";
import TariffModifierList from "@/components/settings/pricing/TariffModifierList.vue";

import qs from "qs";
import axios from "axios";
import RideTypeLuggagePassengerForm from '@/components/luggage/RideTypeLuggagePassengerForm'
axios.defaults.withCredentials = true;

export default {
  name: "edit_ride_type",
  components: {
    RideTypeLuggagePassengerForm,
    RideTypeForm,
    TariffModifierForm,
    TariffModifierList,
  },
  props: {},
  data: function () {
    return {
      showLuggageFormDialog: false,
      rideType: null,
      tariff: null,
      errors: {},
      rideTypeFormValid: false,
      showModifierDialog: false,
      tariffModifierData: {},
      editModifierIndex: -1,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      loading: true,
      disabled: false,
    };
  },
  mounted: function () {
    console.log("Mounted");
    this.getRideTypeInfo();
  },
  methods: {
    deleteRecord(id) {
      this.$store.dispatch('rideType/deleteRideTypeCapacity', id).then(res => {
        this.getRideTypeInfo()
      })
    },
    getRideTypeInfo: async function () {
      this.disabled = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/settings/ride_types/${this.$route.params.id}/get`;

      console.log("Getting ride type info");

      axios
        .get(url)
        .then(function (response) {
          if (!response.error) {
            if (response.data.ride_type && response.data.tariff) {
              self.disabled = false;
              self.rideType = response.data.ride_type;
              self.tariff = response.data.tariff;
              self.convertTariffPenceToPounds();
              self.tariff.modifiers.sort(function (a, b) {
                return a.priority - b.priority;
              });
            } else {
              self.rideType = {};
              self.tariff = {};
              self.showSnackbar(
                "Error fetching ride type, missing data",
                "error"
              );
            }
          } else {
            console.log(response.error);
            self.rideType = {};
            self.tariff = {};
            self.showSnackbar(
              "Error fetching ride type: " + response.error,
              "error"
            );
          }
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          self.rideType = {};
          self.tariff = {};
          self.showSnackbar(error, "error");
          self.loading = false;
        });
    },
    update: async function () {
      if (!this.showModifierDialog) {
        if (this.rideTypeFormValid) {
          let self = this;
          let url = `${this.$store.state.apiUrl}/settings/ride_types/${this.$route.params.id}/update`;

          var rideType = JSON.parse(JSON.stringify(this.rideType));

          rideType.name = encodeURIComponent(this.rideType.name);
          rideType.alternative_name = encodeURIComponent(
            rideType.alternative_name
          );
          rideType.description = encodeURIComponent(this.rideType.description);

          axios({
            url: url,
            method: "post",
            data: JSON.stringify({
              ride_type: rideType,
              tariff: this.convertTariffPoundsToPence(),
            }),
            headers: {
              "Content-Type": "text/plain",
            },
          })
            .then(function (response) {
              if (response.data.errors) {
                self.errors = response.data.errors;
                if (self.errors.ride_type && self.errors.tariff) {
                  self.errors = {
                    ...self.errors.ride_type,
                    ...self.errors.tariff,
                  };
                }
                console.log(self.errors);
                self.showSnackbar(
                  "Error updating ride type, please check the form",
                  "error"
                );
              } else if (response.data.error != "no_error") {
                self.showSnackbar(
                  "Error updating ride type: " + response.data.error,
                  "error"
                );
                console.log(response.data.error);
              } else {
                self.$router.push("/settings/pricing/ride_types/");
              }
            })
            .catch(function (error) {
              console.log(error);
              self.showSnackbar("Network error: " + error, "error");
            });
        } else {
          this.showSnackbar(
            "Please complete the form before submitting",
            "error"
          );
          this.$refs.rideTypeForm.validateForm();
        }
      } else {
        this.showSnackbar(
          "Please finish adding/editing the modifier before submitting",
          "error"
        );
      }
    },
    updateFormValidity: function (value) {
      this.rideTypeFormValid = value;
    },
    handleImageInput: function (file) {
      this.rideType.image = file;
    },
    handleAlternativeImageInput: function (file) {
      this.rideType.alternative_image = file;
    },
    showSnackbar: function (message, colour) {
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
    addTariffModifier: function () {
      this.tariffModifierData = {
        name: "",
        //Default to last priority
        priority:
          this.tariff.modifiers == null ? 1 : this.tariff.modifiers.length + 1,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        bank_holiday: false,
        hour_period_start: "",
        hour_period_end: "",
        day_period_start_date: "",
        day_period_start_month: "",
        day_period_start_time: "",
        day_period_end_date: "",
        day_period_end_month: "",
        day_period_end_time: "",
        base_fare: "",
        per_mile_fare: "",
        per_minute_fare: "",
        additional_charge: "",
      };

      this.modifierIndex = -1;
      this.showModifierDialog = true;
    },
    cancelTariffModifier: function () {
      this.showModifierDialog = false;
      this.modifierIndex = -1;
    },
    saveTariffModifier: function (modifier) {
      if (this.modifierIndex == -1) {
        this.tariff.modifiers.push(modifier);
      } else {
        //https://vuejs.org/2016/02/06/common-gotchas/
        //this.tariff.modifiers[this.modifierIndex] = modifier;
        this.tariff.modifiers.splice(this.modifierIndex, 1, modifier);
      }
      this.showModifierDialog = false;
      this.modifierIndex = -1;
    },
    editTariffModifier: function (index) {
      this.tariffModifierData = Object.assign({}, this.tariff.modifiers[index]);
      this.modifierIndex = index;
      this.showModifierDialog = true;
    },
    changeModifierOrder: function (newModifiers) {
      for (let i = 0; i < newModifiers.length; i++) {
        newModifiers[i].priority = i + 1;
      }
      this.tariff.modifiers = newModifiers;
      this.tariff.modifiers.sort(function (a, b) {
        return a.priority - b.priority;
      });
    },
    convertTariffPenceToPounds: function () {
      this.tariff.base_fare = this.tariff.base_fare / 100;
      this.tariff.per_mile_fare = this.tariff.per_mile_fare / 100;
      this.tariff.per_minute_fare = this.tariff.per_minute_fare / 100;
      this.tariff.additional_charge = this.tariff.additional_charge / 100;

      this.tariff.modifiers.forEach(function (modifier) {
        modifier.base_fare = modifier.base_fare / 100;
        modifier.per_mile_fare = modifier.per_mile_fare / 100;
        modifier.per_minute_fare = modifier.per_minute_fare / 100;
        modifier.additional_charge = modifier.additional_charge / 100;
      });
    },
    convertTariffPoundsToPence: function () {
      //Copy not use reference
      let newTariff = JSON.parse(JSON.stringify(this.tariff));

      newTariff.base_fare = Math.round(newTariff.base_fare * 100);
      newTariff.per_mile_fare = Math.round(newTariff.per_mile_fare * 100);
      newTariff.per_minute_fare = Math.round(newTariff.per_minute_fare * 100);
      newTariff.additional_charge = newTariff.additional_charge * 100;

      newTariff.modifiers.forEach(function (modifier) {
        modifier.base_fare = Math.round(modifier.base_fare * 100);
        modifier.per_mile_fare = Math.round(modifier.per_mile_fare * 100);
        modifier.per_minute_fare = Math.round(modifier.per_minute_fare * 100);
        modifier.additional_charge = Math.round(
          modifier.additional_charge * 100
        );
      });

      return newTariff;
    },
  },
};
</script>